import PropTypes from "prop-types";

import TemplatePresenter from "presenters/TemplatePresenter";
import { getPrimaryTag } from "utils/tagUtils";
import { isPresent } from "utils/storeUtils";
import Presenter from "utils/PropTypesPresenter";
import TagPresenter from "presenters/TagPresenter";
import MakeMessagePresenter from "presenters/MakeMessagePresenter";

export default new Presenter(
  {
    id: PropTypes.string,
    type: PropTypes.string,
    thumbnail: PropTypes.string,
    castings: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        type: PropTypes.string,
        roleRank: PropTypes.number,
        headAsset: PropTypes.string,
        jawSvg: PropTypes.string,
      }),
    ),
    userStatus: PropTypes.string,
    makeMessage: MakeMessagePresenter.shape(),
    tags: PropTypes.string,
    template: TemplatePresenter.shape(),
    status: PropTypes.string.isRequired,
  },
  {
    webglPositionData(m) {
      const { webglPositionData } = this.template(m);
      return webglPositionData;
    },
    webglFeatureVideo(m) {
      const { webglFeatureVideo } = this.template(m);
      return webglFeatureVideo;
    },
    positionData(m) {
      const { positionData } = this.template(m);
      return positionData;
    },
    manifest(m) {
      const { manifest } = this.template(m);
      return manifest;
    },
    hasStreamingAssets(m) {
      return isPresent(this.manifest(m)) && isPresent(this.positionData(m));
    },
    isOwner(m) {
      return this.userStatus(m) === "owner";
    },
    isRecipient(m) {
      return this.userStatus(m) === "recipient";
    },
    isDraft(m) {
      return this.status(m) === "draft";
    },
    isLive(m) {
      return this.status(m) === "live";
    },
    notOwnerButtonText(m) {
      const tags = this.tags(m);
      const primaryTag = getPrimaryTag(tags);
      return TagPresenter.notOwnerButtonText(primaryTag);
    },
    notOwnerButtonPath(m, templateGroupId) {
      const tags = this.tags(m);
      const primaryTag = getPrimaryTag(tags);
      return TagPresenter.notOwnerButtonPath(primaryTag, templateGroupId);
    },
    templateGroupId(m) {
      return m?.template?.templateGroupSlug;
    },
  },
);
